export default {
  compras: [],
  selectedCompra: null,
  error: false,
  errorMessage: [],
}
